export const ADD_PRODUCT_TO_PROVIDER = `
  mutation AddProductToProvider(
    $providerId: ID!
    $productId: ID!
    $interestPerAnnum: Float
    $commissionFee: Float
    $processingFee: Float
    $insuranceFee: Float
    $maxAmount: Float
    $maxTenor: Int
    $minAmount: Float
    $maxBalancePercentageAccessible: Float
    $lienAmountMultiplier: Float
    $premium: Float
  ) {
    addProductToProvider(
      providerId: $providerId
      productId: $productId
      interestPerAnnum: $interestPerAnnum
      commissionFee: $commissionFee
      processingFee: $processingFee
      insuranceFee: $insuranceFee
      maxAmount: $maxAmount
      maxTenor: $maxTenor
      minAmount: $minAmount
      maxBalancePercentageAccessible: $maxBalancePercentageAccessible
      lienAmountMultiplier: $lienAmountMultiplier
      premium: $premium
    ) {
      providerProduct {
        id
        isActive
        provider {
          id
          name
        }
        product {
          id
          name
          fundCode
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_PROVIDER = `
  mutation CreateProvider(
    $name: String!
    $contactEmail: String
    $ccEmails: [String!]
  ) {
    createProvider(
      name: $name
      contactEmail: $contactEmail
      ccEmails: $ccEmails
    ) {
      provider {
        id
        name
        createdAt
        updatedAt
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_PROVIDER = `
  mutation UpdateProvider(
    $id: ID!
    $name: String
    $contactEmail: String
    $ccEmails: [String!]
    $securedRequiredDocuments: [String!]
    $semiSecuredRequiredDocuments: [String!]
    $unsecuredRequiredDocuments: [String!]
    $promo100RequiredDocuments: [String!]
    $termsAndConditions: String
  ) {
    updateProvider(
      id: $id
      name: $name
      contactEmail: $contactEmail
      ccEmails: $ccEmails
      securedRequiredDocuments: $securedRequiredDocuments
      semiSecuredRequiredDocuments: $semiSecuredRequiredDocuments
      unsecuredRequiredDocuments: $unsecuredRequiredDocuments
      promo100RequiredDocuments: $promo100RequiredDocuments
      termsAndConditions: $termsAndConditions
    ) {
      provider {
        id
        name
        contactEmail
        ccEmails
        securedRequiredDocuments
        semiSecuredRequiredDocuments
        unsecuredRequiredDocuments
        promo100RequiredDocuments
        termsAndConditions
        createdAt
        updatedAt
      }
      errors {
        property
        description
      }
    }
  }
`;

export const REMOVE_PRODUCT_FROM_PROVIDER = `
  mutation RemoveProductFromProvider($providerProductId: ID!) {
    removeProductFromProvider(providerProductId: $providerProductId) {
      providerProduct {
        id
        isActive
        provider {
          id
          name
        }
        product {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_PROVIDERS = `
  query GetProviders($page: ID, $perPage: ID) {
    getProviders(page: $page, perPage: $perPage) {
      id
      name
      createdAt
      updatedAt
      securedRequiredDocuments
      semiSecuredRequiredDocuments
      unsecuredRequiredDocuments
      promo100RequiredDocuments
      activeProviderProducts {
        id
      }
      activeProducts {
        id
        name
        isActive
      }
    }
  }
`;

export const GET_PROVIDER = `
  query GetProvider($id: ID!) {
    getProvider(id: $id) {
      id
      name
      contactEmail
      ccEmails
      securedRequiredDocuments
      semiSecuredRequiredDocuments
      unsecuredRequiredDocuments
      promo100RequiredDocuments
      termsAndConditions
      createdAt
      updatedAt
      products {
        id
        name
        fundCode
      }
      activeProducts {
        id
        name
        fundCode
        transactionFields
      }
      activeProviderProducts {
        id
        isActive
        createdAt
        updatedAt
        product {
          id
          name
          fundCode
          transactionFields
        }
      }
    }
  }
`;

export const LOAN_DOCUMENTS = `
  query LoanDocuments {
    loanDocuments {
      id
      name
    }
  }
`;

export const GET_REQUIRED_LOAN_DOCUMENTS = `
  query GetRequiredLoanDocuments(
    $productId: ID!,
    $loanType: String!
  ) {
    getRequiredLoanDocuments(
      productId: $productId,
      loanType: $loanType
    ) {
      id
      name
    }
  }
`;

export const GET_PROVIDER_PRODUCTS = `
  query GetProviderProducts($id: ID!) {
    getProvider(id: $id) {
      id
      name
      activeProviderProducts {
        id
        isActive
        createdAt
        updatedAt
        product {
          id
          name
          fundCode
        }
      }
    }
  }
`;

export const CREATE_LOAN_REQUEST = `
  mutation CreateLoanRequest(
    $customerId: ID!,
    $companyId: ID!,
    $providerId: ID!,
    $productId: ID!,
    $loanType: String!,
    $customerSubscriptionId: ID!,
    $loanAmountRequested: Float!,
    $loanTenureMonths: Int!,
    $loanPurpose: String,
    $loanDuration: Int,
    $portionOfContributionToBeUsed: [String!]!,
    $source: String!,
    $ghanaCardFrontUrl: String,
    $ghanaCardBackUrl: String,
    $passportUrl: String,
    $applicationFormUrl: String,
    $threeMonthsPayslipUrl: String,
    $standingOrderUrl: String,
    $threeMonthBankStatementUrl: String,
    $threeMomoStatementUrl: String,
    $oneYearConsistentTier2ContributionUrl: String,
    $clearanceFormUrl: String,
    $settlementQuotationUrl: String,
    $sixMonthsBankStatementUrl: String,
    $sixMonthsPayslipsUrl: String,
    $employmentOfferLetterUrl: String,
    $borrowersMandateUrl: String,
    $guarantorFormsUrl: String,
    $salesPersonId: ID
  ) {
    createLoanRequest(
      customerId: $customerId
      companyId: $companyId
      providerId: $providerId
      productId: $productId
      loanType: $loanType
      customerSubscriptionId: $customerSubscriptionId
      loanAmountRequested: $loanAmountRequested
      loanTenureMonths: $loanTenureMonths
      loanPurpose: $loanPurpose
      loanDuration: $loanDuration
      portionOfContributionToBeUsed: $portionOfContributionToBeUsed
      source: $source
      ghanaCardFrontUrl: $ghanaCardFrontUrl
      ghanaCardBackUrl: $ghanaCardBackUrl
      passportUrl: $passportUrl
      applicationFormUrl: $applicationFormUrl
      threeMonthsPayslipUrl: $threeMonthsPayslipUrl
      standingOrderUrl: $standingOrderUrl
      threeMonthBankStatementUrl: $threeMonthBankStatementUrl
      threeMomoStatementUrl: $threeMomoStatementUrl
      oneYearConsistentTier2ContributionUrl: $oneYearConsistentTier2ContributionUrl
      clearanceFormUrl: $clearanceFormUrl
      settlementQuotationUrl: $settlementQuotationUrl
      sixMonthsBankStatementUrl: $sixMonthsBankStatementUrl
      sixMonthsPayslipsUrl: $sixMonthsPayslipsUrl
      employmentOfferLetterUrl: $employmentOfferLetterUrl
      borrowersMandateUrl: $borrowersMandateUrl
      guarantorFormsUrl: $guarantorFormsUrl
      salesPersonId: $salesPersonId
    ) {
      loanRequest {
        id
        customer {
          id
          firstName
          lastName
        }
        company {
          id
          name
        }
        provider {
          id
          name
        }
        product {
          id
          name
          fundCode
        }
        customerSubscription {
          id
        }
        loanType
        loanSecurityType
        loanAmountRequested
        loanTenureMonths
        loanPurpose
        loanDuration
        portionOfContributionToBeUsed
        source
        state
        createdAt
        updatedAt
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_ACTIVE_PRODUCTS_FOR_PROVIDER = `
  query GetActiveProductsForProvider($id: ID!) {
    getProvider(id: $id) {
      id
      name
      activeProducts {
        id
        name
        fundCode
      }
    }
  }
`;

export const GET_LOAN_REQUESTS = `
  query GetLoanRequests($page: ID, $perPage: ID, $customerId: ID, $providerId: ID) {
    getLoanRequests(page: $page, perPage: $perPage, customerId: $customerId, providerId: $providerId) {
      count
      results {
        id
        source
        customer {
          id
          firstName
          lastName
          petraId
        }
        provider {
          id
          name
        }
        product {
          id
          name
          fundCode
        }
        customerSubscription {
          id
        }
        loanType
        loanSecurityType
        state
        loanAmountRequested
        loanTenureMonths
        loanPurpose
        maxLoanAmount
        loanDuration
        portionOfContributionToBeUsed
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_LOAN_REQUEST = `
  query GetLoanRequest($id: ID!) {
    getLoanRequest(id: $id) {
      id
      source
      disbursedAt
      disbursedAmount
      salesPerson{
        id
        name
      }
      loanRequestNotes {
        id
        note {
          id
          description
          createdAt
          updatedAt
          user {
            id
            name
          }
        }
      }
      customerLien {
        id
        currentAmount
        totalAmount
        loanPaid
        provider
        employeePreTax
        employeePostTax
        employerPreTax
        employerPostTax
      }
      finalLoanBreakdown
      loanBreakdown{
        data
        error
        success
      }
      company {
        id
        name
      }
      customer {
        id
        firstName
        lastLoanRequestKyc {
          id
          loanRequest{
            customer{
              ghanaCardIdUrl
              ghanaCardIdBackUrl
            }
          }
          fullName
          email
          phoneNumber
          dateOfBirth
          gender
          residentialAddress
          occupation
          employerName
          monthlyIncome
          idType
          idNumber
          idExpiryDate
          maritalStatus
          numberOfDependents
          nextOfKinName
          nextOfKinRelationship
          nextOfKinPhone
          nextOfKinAddress
          collateralType
          collateralDescription
          collateralValue
          bankName
          bankAccountNumber
          bankAccountName
          modeOfRepayment
          notes
        }
        middleName
        lastName
        idExpiryDate
        ghanaCardIdUrl
        ghanaCardIdBackUrl
        ghanaCardNo
        gender
        dateOfBirth
        petraId
        activeCustomerPhones {
          id
          phone {
            id
            number
            type
          }
          isPrimary
          isActive
        }
        customerAddresses {
          id
          address {
            id
            streetName
            ghPost
            poBox
            region
            city
            isPostalBox
            country {
              id
              name
            }
          }
          isPrimary
          isActive
        }
        customerEmails {
          id
          email {
            id
            address
          }
          isPrimary
          isActive
        }
        employers {
          id
          name
          industrySector {
            name
          }
          petraId
          tinNumber
        }
      }
      provider {
        id
        name
      }
      product {
        id
        name
        fundCode
      }
      customerSubscription {
        id
      }
      loanRequestKyc {
        id
        fullName
        email
        phoneNumber
        dateOfBirth
        gender
        residentialAddress
        occupation
        employerName
        monthlyIncome
        idType
        idNumber
        idExpiryDate
        maritalStatus
        numberOfDependents
        nextOfKinName
        nextOfKinRelationship
        nextOfKinPhone
        nextOfKinAddress
        collateralType
        collateralDescription
        collateralValue
        bankName
        bankAccountNumber
        bankAccountName
        modeOfRepayment
        notes
        title
        maidenName
        contactPersonTitle
        nationality
        hometown
        secondaryPhoneNumber
        educationalQualification
        digitalAddress
        postalAddress
        townCity
        nearestLandmark
        residencyYears
        residenceType
        idIssueDate
        dateEmployed
        designation
        officeLocation
        employerEmail
        employerPhone
        employmentStatus
        employeeStaffId
        netMonthlyIncome
        totalAllowance
        totalDeductions
        salaryPaymentDay
        tin
        officeLandmark
        officeTownCity
        officeDigitalAddress
        fundUsedToSecure
        disbursementMode
        disbursementIsSalaryAccount
        secondaryRepaymentMode
        contactPersonEmail
        contactPersonOccupation
        contactPersonPlaceOfWork
      }
      loanType
      loanSecurityType
      state
      loanAmountRequested
      loanTenureMonths
      loanPurpose
      maxLoanAmount
      loanDuration
      portionOfContributionToBeUsed
      canTransitionToNextStates
      notifierRecords {
        id
        notificationType
        status
        message
        recipient
        reference
        createdAt
        updatedAt
        customer {
          id
          petraId
        }
        company {
          id
          petraId
        }
      }
      ghanaCardFrontUrl
      ghanaCardBackUrl
      passportUrl
      applicationFormUrl
      filledApplicationFormUrl
      filledApplicationFormStatus
      filledApplicationFormFailureReason
      filledApplicationFormFailedAt
      threeMonthsPayslipUrl
      standingOrderUrl
      threeMonthBankStatementUrl
      threeMomoStatementUrl
      oneYearConsistentTier2ContributionUrl
      clearanceFormUrl
      settlementQuotationUrl
      sixMonthsBankStatementUrl
      sixMonthsPayslipsUrl
      employmentOfferLetterUrl
      borrowersMandateUrl
      guarantorFormsUrl
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_LOAN_REQUEST = `
  mutation UpdateLoanRequest(
    $id: ID!
    $customerId: ID
    $companyId: ID
    $providerId: ID
    $productId: ID
    $loanType: String
    $loanSecurityType: String
    $customerSubscriptionId: ID
    $loanAmountRequested: Float
    $loanTenureMonths: Int
    $loanPurpose: String
    $loanDuration: Int
    $portionOfContributionToBeUsed: [String!]
    $ghanaCardFrontUrl: String
    $ghanaCardBackUrl: String
    $passportUrl: String
    $applicationFormUrl: String
    $threeMonthsPayslipUrl: String
    $standingOrderUrl: String
    $threeMonthBankStatementUrl: String
    $threeMomoStatementUrl: String
    $oneYearConsistentTier2ContributionUrl: String
    $clearanceFormUrl: String
    $settlementQuotationUrl: String
    $sixMonthsBankStatementUrl: String
    $sixMonthsPayslipsUrl: String
    $employmentOfferLetterUrl: String
    $borrowersMandateUrl: String
    $guarantorFormsUrl: String
    $salesPersonId: ID
  ) {
    updateLoanRequest(
      id: $id
      customerId: $customerId
      companyId: $companyId
      providerId: $providerId
      productId: $productId
      loanType: $loanType
      loanSecurityType: $loanSecurityType
      customerSubscriptionId: $customerSubscriptionId
      loanAmountRequested: $loanAmountRequested
      loanTenureMonths: $loanTenureMonths
      loanPurpose: $loanPurpose
      loanDuration: $loanDuration
      portionOfContributionToBeUsed: $portionOfContributionToBeUsed
      ghanaCardFrontUrl: $ghanaCardFrontUrl
      ghanaCardBackUrl: $ghanaCardBackUrl
      passportUrl: $passportUrl
      applicationFormUrl: $applicationFormUrl
      threeMonthsPayslipUrl: $threeMonthsPayslipUrl
      standingOrderUrl: $standingOrderUrl
      threeMonthBankStatementUrl: $threeMonthBankStatementUrl
      threeMomoStatementUrl: $threeMomoStatementUrl
      oneYearConsistentTier2ContributionUrl: $oneYearConsistentTier2ContributionUrl
      clearanceFormUrl: $clearanceFormUrl
      settlementQuotationUrl: $settlementQuotationUrl
      sixMonthsBankStatementUrl: $sixMonthsBankStatementUrl
      sixMonthsPayslipsUrl: $sixMonthsPayslipsUrl
      employmentOfferLetterUrl: $employmentOfferLetterUrl
      borrowersMandateUrl: $borrowersMandateUrl
      guarantorFormsUrl: $guarantorFormsUrl
      salesPersonId: $salesPersonId
    ) {
      loanRequest {
        id
        state
        createdAt
        updatedAt
      }
      errors {
        description
        property
      }
    }
  }
`;

export const GET_LOAN_REQUEST_LOGS = `
  query GetLoanRequestLogs($loanRequestId: ID!) {
    loanRequestChangeLogs(loanRequestId: $loanRequestId) {
      audits {
        auditItem
        createdAt
        action
        newValue
        oldValue
        user
        comment
      }
      stateAudits {
        auditItem
        createdAt
        action
        newValue
        oldValue
        user
        comment
      }
    }
  }
`;

export const MOVE_LOAN_REQUEST_TO_STATE = `
  mutation MoveLoanRequestToState(
    $loanRequestId: ID!
    $state: String!
    $event: String!
    $comment: String
    $disbursedAt: ISO8601DateTime
    $disbursedAmount: Float
  ) {
    moveLoanRequestToState(
      loanRequestId: $loanRequestId
      state: $state
      event: $event
      comment: $comment
      disbursedAt: $disbursedAt
      disbursedAmount: $disbursedAmount
    ) {
      loanRequest {
        id
        state
        createdAt
        updatedAt
      }
      errors {
        description
        property
      }
    }
  }
`;

export const REGENERATE_LOAN_APPLICATION_FORM = `
  mutation RegenerateLoanApplicationForm($loanRequestId: ID!) {
    regenerateLoanApplicationForm(loanRequestId: $loanRequestId) {
      loanRequest {
        id
        state
        filledApplicationFormUrl
        filledApplicationFormFailedAt
      }
      errors {
        description
        property
      }
    }
  }
`;

export const ASSIGN_NOTE_TO_LOAN_REQUEST = `
  mutation AssignNoteToLoanRequest($noteId: ID!, $loanRequestId: ID!) {
    assignNoteToLoanRequest(noteId: $noteId, loanRequestId: $loanRequestId) {
      loanRequestNote {
        id
        note {
          id
          description
          createdAt
          user {
            id
            name
          }
        }
      }
    }
  }
`;

export const ASSIGN_ATTACHMENT_TO_LOAN_REQUEST = `
  mutation AssignAttachmentsToLoanRequest($attachmentIds: [ID!]!, $loanRequestId: ID!) {
    assignAttachmentsToLoanRequest(attachmentIds: $attachmentIds, loanRequestId: $loanRequestId) {
      loanRequest {
        loanRequestAttachments {
          id
          attachment {
            id
            url
            name
            createdAt
          }
        }
      }
    }
  }
`;

export const UNASSIGN_ATTACHMENT_FROM_LOAN_REQUEST = `
  mutation UnassignAttachmentFromLoanRequest($id: ID!) {
    unassignAttachmentFromLoanRequest(id: $id) {
      result
      errors {
        description
        property
      }
    }
  }
`;

export const GET_LOAN_REQUEST_FOR_EDIT = `
  query GetLoanRequest($id: ID!) {
    getLoanRequest(id: $id) {
      id
      salesPerson{
        id
        name
      }
      customerSubscription {
        id
        product {
          id
          name
          fundCode
        }
      }
      finalLoanBreakdown
      loanBreakdown{
        data
        error
        success
      }
      company {
        id
        name
      }
      customer {
        id
        firstName
        middleName
        lastName
        customerSubscriptions {
          id
          product {
            id
            name
            isActive
            fundCode
          }
          computedFirstContributionDate
          firstTierContributionDate
          firstSchemeContributionDate
          proofOfContributionDocumentUrl
        }
        ghanaCardIdUrl
        ghanaCardIdBackUrl
        ghanaCardNo
        gender
        dateOfBirth
        petraId
        activeCustomerPhones {
          id
          phone {
            id
            number
            type
          }
          isPrimary
          isActive
        }
        customerAddresses {
          id
          address {
            id
            streetName
            ghPost
            poBox
            region
            city
            isPostalBox
            country {
              id
              name
            }
          }
          isPrimary
          isActive
        }
        customerEmails {
          id
          email {
            id
            address
          }
          isPrimary
          isActive
        }
        employers {
          id
          name
          industrySector {
            name
          }
          petraId
          tinNumber
        }
      }
      provider {
        id
        name
      }
      product {
        id
        name
        fundCode
      }
      customerSubscription {
        id
      }
      loanType
      loanSecurityType
      state
      loanAmountRequested
      loanTenureMonths
      loanPurpose
      maxLoanAmount
      loanDuration
      portionOfContributionToBeUsed
      canTransitionToNextStates
      ghanaCardFrontUrl
      ghanaCardBackUrl
      passportUrl
      applicationFormUrl
      filledApplicationFormUrl
      filledApplicationFormStatus
      filledApplicationFormFailureReason
      filledApplicationFormFailedAt
      threeMonthsPayslipUrl
      standingOrderUrl
      threeMonthBankStatementUrl
      threeMomoStatementUrl
      oneYearConsistentTier2ContributionUrl
      clearanceFormUrl
      settlementQuotationUrl
      sixMonthsBankStatementUrl
      sixMonthsPayslipsUrl
      employmentOfferLetterUrl
      borrowersMandateUrl
      guarantorFormsUrl
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_LOAN_REQUEST_KYC = `
  mutation CreateLoanRequestKyc(
    $loanRequestId: ID!
    $fullName: String!
    $email: String!
    $phoneNumber: String!
    $dateOfBirth: ISO8601Date!
    $gender: String!
    $residentialAddress: String!
    $occupation: String!
    $employerName: String
    $monthlyIncome: Float!
    $idType: String!
    $idNumber: String!
    $idExpiryDate: ISO8601Date
    $maritalStatus: String
    $numberOfDependents: Int
    $nextOfKinName: String
    $nextOfKinRelationship: String
    $nextOfKinPhone: String
    $nextOfKinAddress: String
    $collateralType: String
    $collateralDescription: String
    $collateralValue: Float
    $bankName: String
    $bankAccountNumber: String
    $bankAccountName: String
    $modeOfRepayment: String
    $notes: String
    $title: String
    $maidenName: String
    $contactPersonTitle: String
    $nationality: String
    $hometown: String
    $secondaryPhoneNumber: String
    $educationalQualification: String
    $digitalAddress: String
    $postalAddress: String
    $townCity: String
    $nearestLandmark: String
    $residencyYears: Int
    $residenceType: String
    $idIssueDate: ISO8601Date
    $dateEmployed: ISO8601Date
    $designation: String
    $officeLocation: String
    $employerEmail: String
    $employerPhone: String
    $employmentStatus: String
    $employeeStaffId: String
    $netMonthlyIncome: Float
    $totalAllowance: Float
    $totalDeductions: Float
    $salaryPaymentDay: String
    $tin: String
    $officeLandmark: String
    $officeTownCity: String
    $officeDigitalAddress: String
    $fundUsedToSecure: String
    $disbursementMode: String
    $disbursementIsSalaryAccount: Boolean
    $secondaryRepaymentMode: String
    $contactPersonEmail: String
    $contactPersonOccupation: String
    $contactPersonPlaceOfWork: String
  ) {
    createLoanRequestKyc(
      loanRequestId: $loanRequestId
      fullName: $fullName
      email: $email
      phoneNumber: $phoneNumber
      dateOfBirth: $dateOfBirth
      gender: $gender
      residentialAddress: $residentialAddress
      occupation: $occupation
      employerName: $employerName
      monthlyIncome: $monthlyIncome
      idType: $idType
      idNumber: $idNumber
      idExpiryDate: $idExpiryDate
      maritalStatus: $maritalStatus
      numberOfDependents: $numberOfDependents
      nextOfKinName: $nextOfKinName
      nextOfKinRelationship: $nextOfKinRelationship
      nextOfKinPhone: $nextOfKinPhone
      nextOfKinAddress: $nextOfKinAddress
      collateralType: $collateralType
      collateralDescription: $collateralDescription
      collateralValue: $collateralValue
      bankName: $bankName
      bankAccountNumber: $bankAccountNumber
      bankAccountName: $bankAccountName
      modeOfRepayment: $modeOfRepayment
      notes: $notes
      title: $title
      maidenName: $maidenName
      contactPersonTitle: $contactPersonTitle
      nationality: $nationality
      hometown: $hometown
      secondaryPhoneNumber: $secondaryPhoneNumber
      educationalQualification: $educationalQualification
      digitalAddress: $digitalAddress
      postalAddress: $postalAddress
      townCity: $townCity
      nearestLandmark: $nearestLandmark
      residencyYears: $residencyYears
      residenceType: $residenceType
      idIssueDate: $idIssueDate
      dateEmployed: $dateEmployed
      designation: $designation
      officeLocation: $officeLocation
      employerEmail: $employerEmail
      employerPhone: $employerPhone
      employmentStatus: $employmentStatus
      employeeStaffId: $employeeStaffId
      netMonthlyIncome: $netMonthlyIncome
      totalAllowance: $totalAllowance
      totalDeductions: $totalDeductions
      salaryPaymentDay: $salaryPaymentDay
      tin: $tin
      officeLandmark: $officeLandmark
      officeTownCity: $officeTownCity
      officeDigitalAddress: $officeDigitalAddress
      fundUsedToSecure: $fundUsedToSecure
      disbursementMode: $disbursementMode
      disbursementIsSalaryAccount: $disbursementIsSalaryAccount
      secondaryRepaymentMode: $secondaryRepaymentMode
      contactPersonEmail: $contactPersonEmail
      contactPersonOccupation: $contactPersonOccupation
      contactPersonPlaceOfWork: $contactPersonPlaceOfWork
    ) {
      loanRequestKyc {
        id
        fullName
        email
        createdAt
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_LOAN_REQUEST_KYC = `
  mutation UpdateLoanRequestKyc(
    $id: ID!
    $fullName: String
    $email: String
    $phoneNumber: String
    $dateOfBirth: ISO8601Date
    $gender: String
    $residentialAddress: String
    $occupation: String
    $employerName: String
    $monthlyIncome: Float
    $idType: String
    $idNumber: String
    $idExpiryDate: ISO8601Date
    $maritalStatus: String
    $numberOfDependents: Int
    $nextOfKinName: String
    $nextOfKinRelationship: String
    $nextOfKinPhone: String
    $nextOfKinAddress: String
    $collateralType: String
    $collateralDescription: String
    $collateralValue: Float
    $bankName: String
    $bankAccountNumber: String
    $bankAccountName: String
    $modeOfRepayment: String
    $notes: String
    $title: String
    $maidenName: String
    $contactPersonTitle: String
    $nationality: String
    $hometown: String
    $secondaryPhoneNumber: String
    $educationalQualification: String
    $digitalAddress: String
    $postalAddress: String
    $townCity: String
    $nearestLandmark: String
    $residencyYears: Int
    $residenceType: String
    $idIssueDate: ISO8601Date
    $dateEmployed: ISO8601Date
    $designation: String
    $officeLocation: String
    $employerEmail: String
    $employerPhone: String
    $employmentStatus: String
    $employeeStaffId: String
    $netMonthlyIncome: Float
    $totalAllowance: Float
    $totalDeductions: Float
    $salaryPaymentDay: String
    $tin: String
    $officeLandmark: String
    $officeTownCity: String
    $officeDigitalAddress: String
    $fundUsedToSecure: String
    $disbursementMode: String
    $disbursementIsSalaryAccount: Boolean
    $secondaryRepaymentMode: String
    $contactPersonEmail: String
    $contactPersonOccupation: String
    $contactPersonPlaceOfWork: String
  ) {
    updateLoanRequestKyc(
      id: $id
      fullName: $fullName
      email: $email
      phoneNumber: $phoneNumber
      dateOfBirth: $dateOfBirth
      gender: $gender
      residentialAddress: $residentialAddress
      occupation: $occupation
      employerName: $employerName
      monthlyIncome: $monthlyIncome
      idType: $idType
      idNumber: $idNumber
      idExpiryDate: $idExpiryDate
      maritalStatus: $maritalStatus
      numberOfDependents: $numberOfDependents
      nextOfKinName: $nextOfKinName
      nextOfKinRelationship: $nextOfKinRelationship
      nextOfKinPhone: $nextOfKinPhone
      nextOfKinAddress: $nextOfKinAddress
      collateralType: $collateralType
      collateralDescription: $collateralDescription
      collateralValue: $collateralValue
      bankName: $bankName
      bankAccountNumber: $bankAccountNumber
      bankAccountName: $bankAccountName
      modeOfRepayment: $modeOfRepayment
      notes: $notes
      title: $title
      maidenName: $maidenName
      contactPersonTitle: $contactPersonTitle
      nationality: $nationality
      hometown: $hometown
      secondaryPhoneNumber: $secondaryPhoneNumber
      educationalQualification: $educationalQualification
      digitalAddress: $digitalAddress
      postalAddress: $postalAddress
      townCity: $townCity
      nearestLandmark: $nearestLandmark
      residencyYears: $residencyYears
      residenceType: $residenceType
      idIssueDate: $idIssueDate
      dateEmployed: $dateEmployed
      designation: $designation
      officeLocation: $officeLocation
      employerEmail: $employerEmail
      employerPhone: $employerPhone
      employmentStatus: $employmentStatus
      employeeStaffId: $employeeStaffId
      netMonthlyIncome: $netMonthlyIncome
      totalAllowance: $totalAllowance
      totalDeductions: $totalDeductions
      salaryPaymentDay: $salaryPaymentDay
      tin: $tin
      officeLandmark: $officeLandmark
      officeTownCity: $officeTownCity
      officeDigitalAddress: $officeDigitalAddress
      fundUsedToSecure: $fundUsedToSecure
      disbursementMode: $disbursementMode
      disbursementIsSalaryAccount: $disbursementIsSalaryAccount
      secondaryRepaymentMode: $secondaryRepaymentMode
      contactPersonEmail: $contactPersonEmail
      contactPersonOccupation: $contactPersonOccupation
      contactPersonPlaceOfWork: $contactPersonPlaceOfWork
    ) {
      loanRequestKyc {
        id
        fullName
        email
        phoneNumber
        dateOfBirth
        gender
        residentialAddress
        occupation
        employerName
        monthlyIncome
        idType
        idNumber
        idExpiryDate
        maritalStatus
        numberOfDependents
        nextOfKinName
        nextOfKinRelationship
        nextOfKinPhone
        nextOfKinAddress
        collateralType
        collateralDescription
        collateralValue
        bankName
        bankAccountNumber
        bankAccountName
        modeOfRepayment
        notes
        title
        maidenName
        contactPersonTitle
        nationality
        hometown
        secondaryPhoneNumber
        educationalQualification
        digitalAddress
        postalAddress
        townCity
        nearestLandmark
        residencyYears
        residenceType
        idIssueDate
        dateEmployed
        designation
        officeLocation
        employerEmail
        employerPhone
        employmentStatus
        employeeStaffId
        netMonthlyIncome
        totalAllowance
        totalDeductions
        salaryPaymentDay
        tin
        officeLandmark
        officeTownCity
        officeDigitalAddress
        fundUsedToSecure
        disbursementMode
        disbursementIsSalaryAccount
        secondaryRepaymentMode
        contactPersonEmail
        contactPersonOccupation
        contactPersonPlaceOfWork
        createdAt
        updatedAt
      }
      errors {
        property
        description
      }
    }
  }
`;

export const LOAN_KYC_DATA = `
  query {
    maritalStatuses {
      id
      name
    }
    idTypes {
      id
      name
    }
  }
`;

export const CHECK_LOAN_BREAKDOWN = `
  query CheckLoanBreakdown(
    $companyPetraId: String!
    $customerPetraId: String!
    $fundCode: String!
    $loanAmount: Float!
    $loanType: String!
    $portionOfContributionToBeUsed: [String!]!
    $endDate: String!
    $loanTenureMonths: Int!
    $loanProductId: ID!
  ) {
    checkLoanBreakdown(
      companyPetraId: $companyPetraId
      customerPetraId: $customerPetraId
      fundCode: $fundCode
      loanAmount: $loanAmount
      loanType: $loanType
      portionOfContributionToBeUsed: $portionOfContributionToBeUsed
      endDate: $endDate
      loanTenureMonths: $loanTenureMonths
      loanProductId: $loanProductId
    ) {
      success
      data
      error
    }
  }
`;

export const GET_LOAN_REQUEST_NOTIFIER_RECORDS_QUERY = `
  query GetLoanRequest($loanRequestId: ID!) {
    getLoanRequest(id: $loanRequestId) {
      notifierRecords {
        id
        notificationType
        status
        message
        recipient
        reference
        createdAt
        updatedAt
        customer {
          id
          petraId
        }
        company {
          id
          petraId
        }
      }
    }
  }
`;

export const CREATE_LOAN_REQUEST_NOTE_TICKET = `
mutation CreateLoanRequestNoteTicket($source: String!, $properties: JSON!, $loanRequestNoteId: String!, $ticketSubCategoryId: ID) {
  createLoanRequestNoteTicket(source: $source, properties: $properties, loanRequestNoteId: $loanRequestNoteId, ticketSubCategoryId: $ticketSubCategoryId){
    ticket {
      id
      properties
      reference
      source
      url
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_LOAN_REQUEST_SORT_FIELDS = `
{
  __type(name: "LoanRequestSortFieldEnum") {
    enumValues {
      name
      description
    }
  }
}
`;

export const SEARCH_LOAN_REQUESTS = `
  query LoanRequestSearch($page: ID!, $q: String!, $numberPerPage: ID, $states: [String!], $providerIds: [ID!], $orderBy: LoanRequestOrderByInput) {
    loanRequestSearch(page: $page, q: $q, numberPerPage: $numberPerPage, states: $states, providerIds: $providerIds, orderBy: $orderBy) {
      count
      results {
        id
        loanType
        state
        source
        loanAmountRequested
        loanTenureMonths
        loanDuration
        loanPurpose
        loanSecurityType
        createdAt
        updatedAt
        customer {
          id
          firstName
          lastName
          petraId
        }
        provider {
          id
          name
        }
        product {
          id
          name
          fundCode
        }
      }
    }
  }
`;
